import React from "react";
import { BaseIconProps } from "../../types/styles";

const CapsuleRiskMapIcon = ({
    id,
    className,
    size = 37,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-crm"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 37 37"
            fill="none"
        >
            <path
                d="M18.5 27.2413C19.5329 27.2413 20.6738 27.4263 22.2771 27.8734C24.4508 28.4284 26.7017 28.9988 28.7829 27.75C31.6042 26.0696 33.115 22.4467 32.93 19.0242C32.745 15.355 30.7408 12.7496 28.0429 11.0538C25.4838 9.40421 22.015 8.52546 18.5 8.49463C14.985 8.51005 11.5163 9.38879 8.95709 11.0384C6.25918 12.7342 4.25501 15.3396 4.07001 19.0088C3.88501 22.4159 5.39584 26.0388 8.21709 27.7346C10.2829 28.9834 12.5492 28.413 14.7229 27.858C16.3263 27.4109 17.4671 27.2413 18.5 27.2259V27.2413Z"
                stroke={color}
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.5 8.51001V27.2413"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.9454 19.2092H4.05457"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CapsuleRiskMapIcon;
